import React, { Component } from 'react';
import { Modal, AutoComplete, Select, Input, message, Radio } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group
const { Option } = Select

class ConditionsConfirmed extends Component {
    state = {
        params: {},
        visible: false,
        secondLineName:null,
        canCreat:null,
    }

    show = ( params ) =>{
        this.setState({
            visible:true,
            params:{...params}
        })
    }

    isOk = () =>{
        const { canCreat ,secondLineName } = this.state;
        const { canEditByInvStatus , update} = this.props;
        if(canCreat == null) {
            message.error('请选择是否确认新建计划需求');
            return;
        }
        if( canCreat ) {
            this.hide();
            canEditByInvStatus(() => update({}, 'add'));
        }else if(secondLineName == null){
            message.error('请选择变更的执行业务线二级分类');
            return;
        }else{
            this.submit()
        }
    }

    submit = () =>{
        const { secondLineName } = this.state;
        let secondLineNames = {secondLineName:''}
        if(typeof(secondLineName) == typeof([])){
            secondLineName.forEach((el,index) =>{
                if(index == secondLineName.length-1){
                    secondLineNames.secondLineName = secondLineNames.secondLineName+el
                }else{
                    secondLineNames.secondLineName = secondLineNames.secondLineName+el+','
                }
            })
        }else {
            secondLineNames={secondLineName}
        }
        const options = {
            method: 'POST',
            url: API_URL.member.sendSecondLineChangeMessage,
            data: {...secondLineNames},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    // handleChange = (value ,key) =>{
    //     searchParams[key] = value;
    //     this.setState({ searchParams });
    // }
    
    hide = () => {
        this.setState({
            visible: false,
            secondLineName:null,
            canCreat:null,
        });
    }

    render() {
        const { visible , params , canCreat } = this.state;
        const { lineOfBusiness ,lineOfBusinessString , secondLineName , invNature } = params;
        const {businessList} = this.props
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title={`新建计划需求条件确认`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.isOk}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="380px"
            >
                <div className="modal-content" style={{ padding: '0 5px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>业务线 :</div>
                            <div className="item-right">
                                {lineOfBusinessString}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>执行业务线二级分类 :</div>
                            <div className="item-right">
                                {secondLineName}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>项目性质 :</div>
                            <div className="item-right">
                                {invNature}
                            </div>
                        </li>
                    </ul>
                    <RadioGroup onChange={(e) => this.setState({canCreat:e.target.value,secondLineName:null})} value={canCreat} style={{ padding: '0 10px' }}>
                        <Radio style={radioStyle} value={1}>是，确认新建计划需求</Radio>
                        <Radio style={radioStyle} value={0}>否，执行业务线二级分类有变更</Radio>
                    </RadioGroup>
                    {
                        canCreat == 0 && lineOfBusinessString !== 'ARO' &&
                        <div style={{marginLeft:'40px'}}>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 200}}
                                disabled={!lineOfBusiness}
                                onChange={value => this.setState({secondLineName:value})}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                    }
                    {
                        canCreat == 0 && lineOfBusinessString == 'ARO' &&
                        <div style={{marginLeft:'40px'}}>
                            <Select
                                mode="multiple"
                                placeholder="请选择"
                                style={{width: 200}}
                                disabled={!lineOfBusiness}
                                onChange={value => this.setState({secondLineName:value})}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default ConditionsConfirmed;


// WEBPACK FOOTER //
// ./src/components/user/require/conditionsConfirmed.js